var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MuiTooltip from "@mui/material/Tooltip";
import { Box } from "@mui/material";
import { COLORS } from "../../../constants/colors";
var shadow = "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)";
var WhiteTooltip = function (_a) {
    var children = _a.children, _b = _a.testId, testId = _b === void 0 ? "" : _b, _c = _a.arrow, arrow = _c === void 0 ? true : _c, _d = _a.placement, placement = _d === void 0 ? "top" : _d, _e = _a.enterTouchDelay, enterTouchDelay = _e === void 0 ? 0 : _e, rest = __rest(_a, ["children", "testId", "arrow", "placement", "enterTouchDelay"]);
    return (_jsx(MuiTooltip, __assign({ "data-testid": "Tooltip-".concat(testId), arrow: arrow, placement: placement, enterTouchDelay: enterTouchDelay, componentsProps: {
            tooltip: {
                sx: {
                    backgroundColor: COLORS.WHITE,
                    px: 3,
                    fontSize: "12px",
                    letterSpacing: "0.4px",
                    boxShadow: shadow,
                },
            },
            arrow: {
                sx: {
                    "::before": {
                        boxShadow: shadow,
                    },
                    color: COLORS.WHITE,
                },
            },
        } }, rest, { children: _jsx(Box, { children: children }) })));
};
export default WhiteTooltip;
